import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "src/styles/App.scss";
import "./config/i18n";
import { markEmbeddedSession } from "src/utils/embedded";

// onceLogin(`/login/:uuid`)로 진입 = eCo OCI iframe 임베드 세션.
// useRouter가 첫 렌더에서 isEmbedded를 확정하므로, 렌더 이전에 플래그를 세워
// 로그인 직후 첫 이동부터 replace가 적용되도록 한다. (뒤로가기 1회로 제품 복귀)
if (/^\/login\/.+/.test(window.location.pathname)) {
  markEmbeddedSession();
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
